import { TrackingContext } from '@vrbo/react-event-tracking';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { createInteractionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';

export const ReadyToList = (props) => {
    const {
        headline,
        subheadline,
        buttonText,
        buttonLink,
        footer1,
        footer2,
        footer3,
        isFrboFlow
    } = props;
    const { trigger } = useContext(TrackingContext);
    const triggerClickstream = (eventName, actionLocation = '', eventVersion = '1.0.0') => {
        trigger('interaction', createInteractionEvent(`${eventName}.selected`, 'Property Onboarding', '', actionLocation, eventVersion));
        return true;
    };

    return (
        <div className="ulx__aem-section ulx__aem-ready-to-list">
            <h2>{headline}</h2>
            <div>{subheadline}</div>
            <a
                href={buttonLink !== 'rtl_link_cta1_list' ? buttonLink : '#'}
                onClick={() => (isFrboFlow
                    ? triggerClickstream('property_manager', '')
                    : triggerClickstream('list_your_property', 'bottom', '2.3.0'))
                }
            >
                <span className="fds-button fds-button-primary">
                    <div className="fds-button-label">{buttonText}</div>
                </span>
            </a>
            <div className="ulx__aem-ready-to-list__cta">
                <div>{footer1}</div>
                {footer2.url && footer2.text
                    && (<div><a href={footer2.url} onClick={() => triggerClickstream('pco_login', '', '2.3.0')}>{footer2.text}</a></div>)}
                {footer3.url && footer3.text
                    && (
                        <div>
                            <a
                                href={footer3.url}
                                onClick={() => triggerClickstream(isFrboFlow ? 'login' : 'vr_login', '', '2.3.0')}
                            >
                                {footer3.text}
                            </a>
                        </div>
                    )}
            </div>

        </div>

    );
};

ReadyToList.propTypes = {
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    footer1: PropTypes.string.isRequired,
    footer2: PropTypes.shape({
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired,
    footer3: PropTypes.shape({
        url: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired,
    isFrboFlow: PropTypes.bool.isRequired
};

export default ReadyToList;
